var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2B2D32",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7197 9.06754C17.7288 9.19545 17.7288 9.32339 17.7288 9.4513C17.7288 13.3528 14.7593 17.8482 9.3319 17.8482C7.65982 17.8482 6.10653 17.364 4.79993 16.5234C5.0375 16.5508 5.2659 16.5599 5.51261 16.5599C6.89229 16.5599 8.16235 16.094 9.17657 15.299C7.87911 15.2716 6.7918 14.4219 6.41717 13.2523C6.59993 13.2797 6.78265 13.298 6.97455 13.298C7.23952 13.298 7.50451 13.2614 7.7512 13.1975C6.39892 12.9234 5.38467 11.7356 5.38467 10.301V10.2645C5.77755 10.4838 6.23444 10.6209 6.71867 10.6391C5.92375 10.1091 5.40295 9.20459 5.40295 8.18124C5.40295 7.63302 5.54912 7.13049 5.80497 6.6919C7.25777 8.48276 9.44154 9.65229 11.8902 9.78023C11.8446 9.56094 11.8171 9.33253 11.8171 9.1041C11.8171 7.47769 13.1329 6.15283 14.7684 6.15283C15.6182 6.15283 16.3857 6.50918 16.9248 7.08481C17.5917 6.9569 18.2313 6.71019 18.7979 6.37212C18.5785 7.05742 18.1126 7.63305 17.5004 7.99851C18.0943 7.93458 18.6699 7.77008 19.1999 7.54167C18.7979 8.12642 18.2953 8.64721 17.7197 9.06754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.79987 4.80017)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.826c7738.svg";
export { ForwardRef as ReactComponent };